export default {
  SET_USERS(state, users) {
    state.users = users;
  },
  SET_META(state, meta) {
    state.meta = meta;
  },
  SET_LINKS(state, links) {
    state.links = links;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_TASKS_COMING_UP(state, tasks) {
    state.tasks_coming_up = tasks;
  },
  SET_PROFILE(state, profile) {
    state.profile = profile;
  },
};
